import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { RazorpayService } from "app/shared/services/razorpay.service";
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-charger-detail",
    templateUrl: "./charger-detail.component.html",
    styleUrls: ["./charger-detail.component.scss"],
})
export class ChargerDetailComponent implements OnInit {
    user_id: any = "";

    charger_id: any = "";
    station_id: any = "";
    connector_id: any = "";
    charger_data: any[] = [];
    amount: number | null = null;
    unit: number | null = null;
    currentBalance: number | null = 0;
    payneed: boolean = true;
    payAmount: number = 0;

    consumption_amt_per_unit = 10;
    charger_type: any = "";
    connector_current_status: any = "";
    connector_type_name: any = "";
    last_ping_datetime: any = "";
    station_name: any = "";

    payment_order_id: any = "";
    payment_id: any = "";

    constructor(
        private _fuseConfigService: FuseConfigService,
        private razorpayService: RazorpayService,
        private snackBar: MatSnackBar,
        private router: Router
    ) {
        // Hide layout elements
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        const rawText = sessionStorage.getItem("charger_data");

        if (!rawText) {
            // Redirect to scan-charger page if no data is found
            this.router.navigate(["/scan-charger"]);
            return;
        }

        this.user_id = sessionStorage.getItem("web_user_id");

        const cleanedText = rawText.replace(/\s+/g, " ").trim();
        const parts = cleanedText.split(" ");

        this.charger_id = parts[0];
        this.station_id = parts[1];
        this.connector_id = parts[2];

        fetch(
            // `https://cmsapi.vmatic.co.in/chrgStation/gtConnectorStatusBySCC/${this.station_id}/${this.charger_id}/${this.connector_id}`
            `${environment.API_URL2}/chrgStation/gtConnectorStatusBySCC/${this.station_id}/${this.charger_id}/${this.connector_id}`
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                this.charger_data = data;
                this.consumption_amt_per_unit =
                    data.data[0].consumption_amt_per_unit;
                this.charger_type = data.data[0].charger_type;
                this.connector_current_status =
                    data.data[0].connector_current_status;
                this.connector_type_name = data.data[0].connector_type_name;
                this.last_ping_datetime = data.data[0].last_ping_datetime;
                this.station_name = data.data[0].station_name;
            })
            .catch((error) => {
                console.error("Fetch error:", error);
            });

        this.getCurrentBalanceByUserID();
    }

    onAmountChange(): void {
        if (this.amount != null && this.amount >= 0) {
            this.unit = parseFloat(
                (this.amount / this.consumption_amt_per_unit).toFixed(2)
            );
            if (this.currentBalance < this.amount) {
                this.payneed = true;
                this.payAmount = Math.ceil(this.amount - this.currentBalance);
            } else {
                this.payneed = false;
                this.payAmount = 0;
            }
        } else {
            this.unit = null;
        }
    }

    onUnitChange(): void {
        if (this.unit != null && this.unit >= 0) {
            this.amount = parseFloat(
                (this.unit * this.consumption_amt_per_unit).toFixed(2)
            );

            if (this.currentBalance < this.amount) {
                this.payneed = true;
                this.payAmount = Math.ceil(this.amount - this.currentBalance);
            } else {
                this.payneed = false;
                this.payAmount = 0;
            }
        } else {
            this.amount = null;
        }
    }

    async pay(): Promise<void> {
        if (!this.amount || this.amount <= 0) {
            this.snackBar.open("Please enter a valid amount.", "Dismiss", {
                duration: 3000,
            });
            return;
        }

        // const amount = this.amount;
        const amount = Math.ceil(this.payAmount);
        const user_id = sessionStorage.getItem("web_user_id");

        const payload = {
            billed_amt: amount,
            user_id,
            ChargerType: "PREPAID",
            station_id: this.station_id,
        };

        try {
            const orderResponse = await fetch(
                // "https://cmsapi.vmatic.co.in/razorpay/createOrder",
                // "https://cmsapi.vmatic.co.in/api-v2/razorpay/createOrder",
                `${environment.API_URL2}/api-v2/razorpay/createOrder`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const orderData = await orderResponse.json();

            if (orderData.status !== "created") {
                throw new Error("Failed to create Razorpay order.");
            }

            this.payment_order_id = orderData.id;

            this.razorpayService.payWithRazorpay(
                amount,
                this.payment_order_id,
                async (paymentResponse: any) => {
                    try {
                        this.payment_id = paymentResponse.razorpay_payment_id;

                        const paymentDetailsResponse = await fetch(
                            // `https://cmsapi.vmatic.co.in/getPaymentDetails/${this.payment_id}/${user_id}/PREPAID`
                            `${environment.API_URL2}/getPaymentDetails/${this.payment_id}/${user_id}/PREPAID`
                        );

                        const paymentData = await paymentDetailsResponse.json();

                        this.router.navigate(["/charger-status"]);
                    } catch (paymentError) {
                        console.error(
                            "Payment verification error:",
                            paymentError
                        );
                        this.snackBar.open(
                            "Payment verification failed.",
                            "Dismiss",
                            {
                                duration: 5000,
                            }
                        );
                    }
                }
            );
        } catch (error) {
            this.snackBar.open(
                "Something went wrong. Please try again.",
                "Dismiss",
                {
                    duration: 5000,
                }
            );
        }
    }

    getCurrentBalanceByUserID(): void {
        // const url = `https://cmsapi.vmatic.co.in/user/app/getCurrentBalanceByUserID/${this.user_id}`;
        const url = `${environment.API_URL2}/user/app/getCurrentBalanceByUserID/${this.user_id}`;

        fetch(url)
            .then((res) => res.json())
            .then((res) => {
                if (res.status) {
                    this.currentBalance = res?.data?.currentBalance;
                }
            })
            .catch((err) => {
                console.error("Fetch connector status error:", err);
            });
    }
}
